<script setup lang="ts">
  import { BaseDocumentView } from '@/widgets/document-view';
  import { TestContentTable, TestContentFilterModal } from '../ui';
  import { TEST_CONTENT_OPTIONS } from '@/shared/config';
</script>

<template>
  <BaseDocumentView
    title="Conteúdo Prova"
    search-url="/document-revisions/awaiting-proof-content/search"
    :table-component="TestContentTable"
    :filter-modal="TestContentFilterModal"
    empty-state-title="Nenhuma prova pendente no momento"
    :custom-order-options="TEST_CONTENT_OPTIONS"
  />
</template>
